export default __webpack_public_path__ + "static/media/flag-barbados.70910b3a.svg";